module.exports = new __parcel__URL__("ride_7.05f04bb8.mp3").toString();